export default "/assets/images/app-update-img-04.7095fe9598a87e47.webp";